import type { AxiosInstance } from 'axios';

/**
 * Sidebar badge counts. Role-agnostic on the wire — the server resolves
 * purchaser vs supplier from the active membership, so the client never has to
 * branch. One field per badged nav item; adding a badge means adding a field
 * here and a matching subquery server-side.
 */
export interface NavCounts {
  rfqs: number;
  orders: number;
}

export type NavCountsService = ReturnType<typeof createNavCountsService>;

export function createNavCountsService(client: AxiosInstance) {
  return {
    get(): Promise<NavCounts> {
      return client.get<NavCounts>('/nav/counts').then((r) => r.data);
    },
  };
}
